//LineChart.vue



<script>

//Import
import { defineComponent } from 'vue';
import { Line } from 'vue3-chart-v2';


var buildingResults = [];
var varStringArr = [];

export default defineComponent({
  name: 'LineChart',
  data() {
		return {
			chartData: {
				// labels: ['Variant 1', 'Variant 2', 'Variant 3', 'Variant 4', 'Variant 5', 'Variant 6', 'Variant 7', 'Variant 8'],
				labels: [],
				datasets: [
					{
						label: "Data 1",
						data: [0, 30, 5, 80, 20, 30, 85, 60, 45, 15],
						backgroundColor: "transparent",
						fill: false,
						borderColor: '#2554FF',
						borderWidth: 2,
						// tension: .2
					}
				]
			},
			options: {
				title: {
					display: true,
					// align: 'start',
					// position: 'top',
					// text: 'Score',
					// font: {
					// 	weight: 'normal',
					// 	size: 72
					// },
				},
				legend: {
					display: false,
					// position: 'bottom',
					maxHeight: 2,
					maxWidth: 20,
					align: 'center',
					fullSize: false,
					labels: {
						fontSize: 12,
						boxWidth: 12,
						usePointStyle: true
					}
				},
				maintainAspectRatio: false,
				scales: {
					ticks: {
						beginAtZero: true,
						fontColor: 'transparent',	//Labels such as 10, 20, etc
						showLabelBackdrop: false	//Hide square behind text
					},
					yAxes: [{
						scaleLabel: {
							display: true,
							// labelString: "Score",
						},
						ticks: {
							fontSize: 10,
							fontColor: 'transparent'
						},
						gridLines: {
							display: false
						}
					}],
					xAxes: 
					[{
						ticks: {
							fontSize: 10
						},
						gridLines: {
							display: false
						}
					}]
				}
			}
		}				
	},
	props: {
	},
	extends: Line,
	mounted () {
		this.getData(); 
		this.setData(); 
		this.setXAxis();
		this.setTooltip();

		this.renderChart(this.chartData, this.options);
  },
  methods: {
	getData() {
		buildingResults = this.$store.state.buildingResults; 
		console.log('buildingResults from nwa');
		console.log(buildingResults);
	},
	setXAxis() {
		
		var variantStringArr = []; 

		for (let i = 0; i < buildingResults.length; i++) {
			var varString = 'Variant ' + (i + 1).toString()
			variantStringArr.push(varString);
		}

		varStringArr = variantStringArr;

		this.chartData.labels = variantStringArr; 
	},
	setData() {

		var dataSet = [];

		var lineChart= this.$store.state.lineChart.toString();
		console.log(lineChart);

		for (let i = 0; i < buildingResults.length; i++) {
			dataSet.push( buildingResults[i][lineChart] );
		}

		this.chartData.datasets[0].data = dataSet;
	},
	setTooltip() {

		var label; 
		var lineChart= this.$store.state.lineChart.toString();

		if		(lineChart == 'carbonData')				{ label = 'Embodied Carbon [kgCO2e]';}
		else if	(lineChart == 'cost')					{ label = 'Costs [EUR]';			}
		else if	(lineChart == 'clearFloorHeight')		{ label = 'Floor Height [m]';	}
		else if	(lineChart == 'structCeilingHeight')	{ label = 'Ceiling Height [m]';	}

		this.chartData.datasets[0].label = label;
	}
  },
})
</script>